// Obsah webu na jednom místě — pro snadnou úpravu textů bez zásahu do komponent.
// Budoucí rubriky (podcasty, články) se doplňují do podcasty.json a clanky.json
// ve stejné složce; veřejně se zobrazí až po naplnění obsahem.
import podcasty from "./podcasty.json";

export const CONTACT = {
  name: "Daniel Pekař",
  phone: "+420 727 865 202",
  phoneHref: "tel:+420727865202",
  email: "danielpekar@icloud.com",
  whatsappHref:
    "https://wa.me/420727865202?text=Dobr%C3%BD%20den%2C%20r%C3%A1d%20bych%20si%20domluvil%20konzultaci%20k%20poji%C5%A1t%C4%9Bn%C3%AD.",
  address: "Ústí nad Labem a okolí",
  area: "Osobní konzultace po dohodě u vás v Ústí nad Labem a okolí, online po celé ČR.",
  ico: "02851717",
  sidlo: "Velká Hradební 746/37, 400 01 Ústí nad Labem",
  // Odkaz na Google profil pro sběr recenzí — doplnit po založení profilu firmy.
  // Tvar: https://g.page/r/XXXX/review (najdete v Správci profilu → „Požádat o recenze")
  googleReview: "",
};

export const NAV_LINKS = [
  { label: "Služby", href: "#pojisteni" },
  { label: "O mně", href: "#o-mne" },
  { label: "Jak spolupráce probíhá", href: "#jak-spoluprace-probiha" },
  { label: "Nebuď šmejd", href: "/pribehy" },
  { label: "Rady pro klienty", href: "/rady" },
  ...(podcasty.length > 0 ? [{ label: "Podcast", href: "/podcasty" }] : []),
  { label: "Kontakt", href: "#kontakt" },
];

// Detailní texty jednotlivých oblastí — návrh ke schválení Danielem.
export const SERVICES = [
  {
    id: "hypoteky",
    group: "uvery",
    icon: "KeyRound",
    title: "Hypotéka na bydlení",
    text: "Od prvního propočtu po čerpání. Srovnám nabídky bank, pohlídám podmínky i termíny, aby vám neujela rezervace.",
    image: "/images/hypoteky.webp",
    imageAlt: "Kalkulačka a model domu při sjednávání hypotéky — ilustrační fotografie",
    intro:
      "Hypotéka je největší finanční rozhodnutí, které většina z nás kdy udělá. Rozdíl mezi bankami se počítá na statisíce — a stejně důležité jsou podmínky, které se nepíšou velkým písmem.",
    when: [
      "Kupujete byt nebo dům — nebo si ho teprve hledáte a chcete vědět, na co dosáhnete.",
      "Stavíte nebo rekonstruujete a potřebujete financovat po etapách.",
      "Nevíte, kolik vlastních peněz budete potřebovat.",
      "Chcete jistotu, že vše stihnete v lhůtách rezervační smlouvy.",
    ],
    solve: [
      "Kolik si můžete reálně dovolit a jak vysokou splátku unese váš rozpočet.",
      "Jaké dokumenty připravit — jiné pro zaměstnance, jiné pro OSVČ a firmy.",
      "Srovnání nabídek bank včetně podmínek, ne jen samotné sazby.",
      "Hlídání termínů, aby vám nepropadla rezervace nemovitosti.",
    ],
  },
  {
    id: "refinancovani",
    group: "uvery",
    icon: "ArrowLeftRight",
    title: "Refinancování hypotéky",
    text: "Končí vám fixace, nebo platíte zbytečně moc? Vyřídím přechod k jiné bance i vyjednání lepších podmínek u té stávající.",
    image: "/images/refinancovani.webp",
    imageAlt: "Vyjednávání podmínek hypotéky u stolu s kalkulačkou a modelem domu — ilustrační fotografie",
    intro:
      "Refinancování umí ušetřit značné peníze. Největší chyba je nechat fixaci prostě doběhnout a přijmout, co banka sama nabídne.",
    when: [
      "Končí vám fixace úrokové sazby.",
      "Platíte víc, než kolik banky nabízejí dnes.",
      "Chcete hypotéku navýšit — třeba na rekonstrukci.",
      "Chcete sloučit více úvěrů do jednoho.",
    ],
    solve: [
      "Jestli se přechod k jiné bance vyplatí, nebo stačí vyjednat lepší podmínky u té stávající.",
      "Načasování — kdy začít, aby vše plynule navazovalo na konec fixace.",
      "Kompletní vyřízení včetně dokumentů a komunikace s bankami.",
    ],
  },
  {
    id: "uvery",
    group: "uvery",
    icon: "Wallet",
    title: "Spotřebitelské úvěry a půjčky",
    text: "Konsolidace půjček i spotřebitelský úvěr bez pastí. Vysvětlím RPSN, poplatky a skutečnou cenu peněz.",
    image: "/images/uvery.webp",
    imageAlt: "Platební karta a notebook při sjednávání úvěru — ilustrační fotografie",
    intro:
      "U spotřebitelských úvěrů rozhoduje skutečná cena peněz — RPSN, poplatky a pojištění, ne reklamní sazba. A někdy je nejlepší úvěr ten, který si nakonec nevezmete.",
    when: [
      "Platíte několik půjček najednou a chcete je sloučit do jedné splátky.",
      "Potřebujete financovat auto, vybavení nebo nečekaný výdaj.",
      "Nabídka vypadá výhodně, ale chcete rozumět všemu, co podepisujete.",
      "Někdo vám nabízí půjčku, u které si nejste jistí.",
    ],
    solve: [
      "Skutečnou cenu úvěru — RPSN, poplatky a pojištění splátek.",
      "Jestli se konsolidace vyplatí a jak ji správně nastavit.",
      "Kdy je úvěr rozumný nástroj — a kdy je lepší počkat.",
    ],
  },
  {
    id: "investice",
    group: "investice",
    icon: "TrendingUp",
    title: "Investice",
    text: "Dlouhodobé budování majetku místo nechávání peněz na účtu. Nastavíme plán podle vašeho horizontu a míry rizika, kterou unesete.",
    image: "/images/investice.webp",
    imageAlt: "Analýza investičních grafů s kalkulačkou — ilustrační fotografie",
    intro:
      "Investování není o hádání trhu, ale o plánu, čase a klidné hlavě. Pravidelné investování dlouhodobě poráží spořicí účet — pokud je nastavené rozumně.",
    when: [
      "Máte rezervu, která na účtu ztrácí hodnotu inflací.",
      "Chcete si budovat majetek na důchod, pro děti, nebo jen pro větší svobodu.",
      "Už investujete, ale bez plánu a spíš náhodně.",
      "Chcete začít, ale bojíte se, že tomu nerozumíte.",
    ],
    solve: [
      "Kolik a jak dlouho investovat, aby to sedělo vašemu cíli.",
      "Kam peníze rozmístit podle míry rizika, kterou psychicky unesete.",
      "Kontrolu poplatků — ty o výsledku rozhodují víc, než se zdá.",
      "Pravidelné přezkoumání, když se změní váš život nebo trhy.",
    ],
  },
  {
    id: "penzijni",
    group: "investice",
    icon: "PiggyBank",
    title: "Penzijní spoření a důchod",
    text: "Doplňkové penzijní spoření i dlouhodobý investiční produkt. Využijeme státní příspěvky a daňové výhody, které stát nabízí.",
    image: "/images/penzijni.webp",
    imageAlt: "Spokojený seniorský pár — důchod bez starostí, ilustrační fotografie",
    intro:
      "Státní důchod sám o sobě na důstojné stáří většinou nestačí. Dobrá zpráva je, že stát při spoření na penzi přispívá — a málokdo to využívá naplno.",
    when: [
      "Chcete si na důchod odkládat pravidelně a s výhodami.",
      "Slyšeli jste o doplňkovém penzijním spoření nebo DIPu a nevíte, co zvolit.",
      "Zaměstnavatel nabízí příspěvek na penzi a vy ho nečerpáte.",
      "Chcete vědět, kolik budete v důchodu vlastně potřebovat.",
    ],
    solve: [
      "Rozdíl mezi doplňkovým penzijním spořením, DIPem a klasickým investováním.",
      "Státní příspěvky a daňové odpočty — kolik reálně získáte.",
      "Kolik si odkládat, aby vám penze vystačila.",
    ],
  },
  {
    id: "zivotni-pojisteni",
    icon: "HeartPulse",
    title: "Životní pojištění a ochrana příjmu",
    text: "Zajištění vás a vaší rodiny pro případ nemoci, úrazu nebo výpadku příjmu. Krytí nastavím podle vaší skutečné životní situace, ne podle tabulek.",
    image: "/images/rodina-podlaha.webp",
    imageAlt: "Rodina spolu doma — ilustrační fotografie",
    intro:
      "Životní pojištění má jediný úkol — zajistit, že vaše rodina zvládne i období, kdy nemůžete pracovat nebo kdy se stane to nejhorší. Nejde o produkt, ale o jistotu, která má odpovídat vašemu skutečnému životu.",
    when: [
      "Máte rodinu nebo děti, které jsou závislé na vašem příjmu.",
      "Splácíte hypotéku nebo jiný úvěr, který by bez vás někdo musel uhradit.",
      "Podnikáte a nemáte zajištění, které zaměstnanci běžně mají.",
      "Chcete mít jistotu i pro případ vážné nemoci nebo trvalých následků úrazu.",
    ],
    solve: [
      "Jak vysoké krytí pro vaši situaci skutečně dává smysl — ani zbytečně vysoké, ani nedostatečné.",
      "Která rizika pojistit a na kterých se nedá smyslně pojistit.",
      "Kontrolu stávající smlouvy — jestli odpovídá vašemu dnešnímu životu, ne životu před lety.",
    ],
  },
  {
    id: "nemovitost-domacnost",
    icon: "House",
    title: "Pojištění nemovitosti a domácnosti",
    text: "Ochrana bytu, domu i vybavení proti požáru, vodě, krádeži a dalším rizikům. Zkontroluji, že pojistné částky odpovídají skutečné hodnotě vašeho majetku.",
    image: "/images/par-pohovka.webp",
    imageAlt: "Spokojení doma na pohovce — ilustrační fotografie",
    intro:
      "Byt nebo dům bývá největší majetek, který kdy pořídíte. Pojištění má krýt skutečnou hodnotu — ne částku, která zůstala ve smlouvě od podpisu před lety.",
    when: [
      "Kupujete byt nebo dům — banka pojištění k hypotéce obvykle vyžaduje.",
      "Rekonstruujete nebo jste nedávno zrekonstruovali a hodnota nemovitosti vzrostla.",
      "Pronajímáte byt či dům, nebo naopak bydlíte v nájmu.",
      "Chcete se chránit proti požáru, vodě, vichřici nebo krádeži.",
    ],
    solve: [
      "Správnou pojistnou částku, aby vám v případě škody nechyběly peníze na opravu.",
      "Rozdíl mezi pojištěním nemovitosti a pojištěním domácnosti — a co z toho potřebujete vy.",
      "Kontrolu výluk a limitů, které se poznají až ve chvíli, kdy je pozdě.",
    ],
  },
  {
    id: "vozidla",
    icon: "Car",
    title: "Pojištění vozidel",
    text: "Povinné ručení i havarijní pojištění bez zbytečných připojištění. Vysvětlím vám, co se vyplatí řešit a co je jen navíc.",
    image: "/images/vozidla.webp",
    imageAlt: "Ruce chránící automobil — ilustrační fotografie",
    intro:
      "Povinné ručení je zákonná povinnost, havarijní pojištění vaše volba. U obojího se vyplatí vědět, co přesně platíte — a co ve smlouvě naopak chybí.",
    when: [
      "Kupujete nové auto, případně auto na úvěr či operativní leasing.",
      "Blíží se výročí smlouvy a chcete porovnat, co nabízí ostatní pojišťovny.",
      "Jezdíte denně a chcete mít jistotu rychlé asistence.",
      "Nevíte, jestli se u vašeho auta havarijní pojištění ještě vyplatí.",
    ],
    solve: [
      "Rozdíl mezi povinným ručením a havarijním pojištěním — srozumitelně a bez povinných balíčků.",
      "Připojištění, která dávají smysl: asistence, čelní sklo, střet se zvěří či GAP u nových aut.",
      "Srovnání nabídek tak, abyste neplatili za to, co nepotřebujete.",
    ],
  },
  {
    id: "odpovednost",
    icon: "ShieldCheck",
    title: "Pojištění odpovědnosti",
    text: "Kryje škody, které nechtěně způsobíte někomu jinému — v běžném životě i při podnikání. Nenápadná ochrana, která řeší velké problémy.",
    image: "/images/odpovednost.webp",
    imageAlt: "Ochrana domácích mazlíčků i okolí — ilustrační fotografie",
    intro:
      "Pojištění odpovědnosti kryje škody, které nechtěně způsobíte někomu jinému. Patří mezi nejlevnější pojištění vůbec — a přitom dokáže vyřešit situace, které by jinak stály statisíce.",
    when: [
      "Máte děti, psa nebo rekreační nemovitost.",
      "Sportujete nebo se věnujete aktivitám, u kterých hrozí úraz někoho jiného.",
      "Podnikáte a za svou práci odpovídáte klientům.",
      "Chcete klid, že nešťastná náhoda neohrozí váš rozpočet.",
    ],
    solve: [
      "Rozsah krytí a limity — kolik pojišťovna skutečně zaplatí a za jakých podmínek.",
      "Jestli je výhodnější samostatná smlouva, nebo odpověnost jako součást pojištění domácnosti.",
      "U podnikatelů návaznost na odpovědnost z podnikání a profesi.",
    ],
  },
  {
    id: "cestovni",
    icon: "Plane",
    title: "Cestovní pojištění",
    text: "Léčebné výlohy, asistence i storno zájezdu. Pojištění nastavím podle toho, kam a jak často cestujete.",
    image: "/images/par-more.webp",
    imageAlt: "Spokojený pár u moře — ilustrační fotografie",
    intro:
      "Léčebné výlohy v zahraničí umějí vyrůst do závratných částek — a evropský průkaz pojištěnce zdaleka nepokryje všechno. Cestovní pojištění je malá investice oproti riziku.",
    when: [
      "Jedete na dovolenou — do Evropy i mimo ni.",
      "Cestujete často, třeba služebně, a jednotlivá smlouva pokaždé nedává smysl.",
      "Plánujete lyže, hory nebo jiné aktivity s vyšším rizikem úrazu.",
      "Chcete pojistit i storno zájezdu nebo zpoždění zavazadel.",
    ],
    solve: [
      "Dostatečné limity léčebných výloh pro konkrétní destinaci.",
      "Asistenční služby a repatriace — co se děje, když se něco stane.",
      "Jestli se vám vyplatí jednorázové, nebo celoroční cestovní pojištění.",
    ],
  },
  {
    id: "podnikatele",
    icon: "Briefcase",
    title: "Pojištění podnikatelů",
    text: "Ochrana podnikání, majetku firmy i odpovědnosti za škodu. Pomohu vám pojistit to, co by ohrozilo vaši živnost.",
    image: "/images/podnikatele.webp",
    imageAlt: "Podpis smlouvy plnicím perem — ilustrační fotografie",
    intro:
      "Podnikání nese jiná rizika než zaměstnání — a pojišťovny to vědí. Správně nastavené pojištění ochrání to, co jste budovali roky, před jedinou nepříjemnou událostí.",
    when: [
      "Začínáte podnikat a chcete mít pojištění v pořádku od prvního dne.",
      "Máte zaměstnance, provozovnu, sklad nebo dražší vybavení.",
      "Za svou práci odpovídáte klientům — chybou i škodou na majetku.",
      "Vaše povolání má pojištění povinné ze zákona.",
    ],
    solve: [
      "Odpovědnost z podnikání a z profese — co kryje a co ne.",
      "Pojištění majetku, zásob a přerušení provozu.",
      "Propojení podnikatelského a osobního pojištění, aby se nic nepřekrývalo ani nechybělo.",
    ],
  },
];

export const ABOUT_POINTS = [
  {
    title: "Naslouchání",
    text: "Než cokoli navrhnu, potřebuji rozumět vaší situaci, rodině i plánům.",
  },
  {
    title: "Srozumitelnost",
    text: "Možnosti vysvětluji česky a bez odborných pojmů, aby rozhodnutí bylo vaše.",
  },
  {
    title: "Prostor pro otázky",
    text: "Na nic se nemusíte ptát dvakrát — ale klidně můžete. Spěch u toho nemá místo.",
  },
  {
    title: "Dlouhodobá péče",
    text: "Pojištění není jednorázový obchod. Zůstávám k dispozici i po podpisu smlouvy.",
  },
];

export const PROCESS_STEPS = [
  {
    number: "01",
    icon: "PhoneCall",
    title: "Nezávazně se spojíme",
    text: "Zavoláme si, napíšeme si nebo se sejdeme — online i osobně. Stačí pár minut a bez závazků.",
  },
  {
    number: "02",
    icon: "ClipboardCheck",
    title: "Probereme vaše potřeby",
    text: "Promluvíme si o vaší životní situaci a podíváme se na současné smlouvy — co je v pořádku a co zaslouží pozornost.",
  },
  {
    number: "03",
    icon: "BadgeCheck",
    title: "Společně vybereme řešení",
    text: "Vysvětlím vám možnosti srozumitelně a bez tlaku. Rozhodnutí je vždycky vaše.",
  },
  {
    number: "04",
    icon: "Repeat",
    title: "Zůstáváme v kontaktu",
    text: "I po sjednání. Při změnách ve vašem životě se ozvu a smlouvy držíme aktuální.",
  },
];

// Instituce, jejichž nabídky Daniel jako samostatný zprostředkovatel srovnává (dle klientky).
// Oficiální loga dodala klientka (zdroje z oficiálních webů institucí).
export const BANKS = [
  { name: "Komerční banka", logo: "/images/loga/komercni-banka.svg" },
  { name: "ČSOB", logo: "/images/loga/csob.svg" },
  { name: "Raiffeisenbank", logo: "/images/loga/raiffeisenbank.svg" },
  { name: "Moneta Money Bank", logo: "/images/loga/moneta.svg" },
  { name: "UniCredit Bank", logo: "/images/loga/unicredit.svg" },
  { name: "Česká spořitelna", logo: "/images/loga/ceska-sporitelna.svg" },
];

export const INSURERS = [
  { name: "ČPP", logo: "/images/loga/cpp.svg" },
  { name: "Generali Česká pojišťovna", logo: "/images/loga/generali-ceska.svg" },
  { name: "UNIQA", logo: "/images/loga/uniqa.svg" },
  { name: "Allianz", logo: "/images/loga/allianz.svg" },
  { name: "NN", logo: "/images/loga/nn.svg" },
  { name: "Kooperativa", logo: "/images/loga/kooperativa.svg" },
];

export const FAQ_ITEMS = [
  {
    question: "Zajišťujete i hypotéky a úvěry?",
    answer:
      "Ano — hypotéky a úvěry tvoří hlavní část mé práce. Pomohu vám s hypotékou na bydlení, refinancováním i spotřebitelským úvěrem, od prvního propočtu přes dokumenty až po podpis.",
  },
  {
    question: "Mohu se ozvat, i když už pojištění mám?",
    answer:
      "Ano, právě kontrola stávajících smluv bývá častým důvodem první schůzky. Projdu s vámi, co máte sjednané, a řeknu vám, jestli to odpovídá vaší současné situaci. Ne vždy je potřeba něco měnit.",
  },
  {
    question: "Co si mám připravit na první schůzku?",
    answer:
      "Vystačíme si s tím, co máte po ruce — smlouvy, které jste dosud sjednali, a představu o tom, co chcete řešit. Všechno ostatní si řekneme společně.",
  },
  {
    question: "Lze konzultaci řešit online?",
    answer:
      "Ano. Kromě osobních schůzek v Ústí nad Labem a po dohodě v regionu se můžeme spojit online — odkudkoli z celé České republiky.",
  },
  {
    question: "Kdy má smysl pojištění znovu zkontrolovat?",
    answer:
      "Vždy při zásadní životní změně — sňatku, narození dítěte, novém bydlení nebo změně zaměstnání či podnikání. Jinak se vyplatí projít smlouvy jednou za pár let.",
  },
  {
    question: "Co je to fixace a jak dlouhou zvolit?",
    answer:
      "Fixace je doba, po kterou máte garantovanou úrokovou sazbu hypotéky. Kratší fixace znamená dřívější změnu podmínek, delší zase delší klid. Univerzálně správná volba neexistuje — záleží na tom, jak dlouho chcete mít jistotu splátky.",
  },
  {
    question: "Kolik vlastních peněz potřebuju k hypotéce?",
    answer:
      "Banky obvykle financují do 80–90 % hodnoty nemovitosti, zbytek doplatíte z vlastního. K tomu připočtěte rezervu na poplatky, případnou rekonstrukci a rezervační poplatek. Spočítáme to spolu podle vaší konkrétní situace.",
  },
  {
    question: "Můžu hypotéku splatit předčasně?",
    answer:
      "Ano, hypotéku lze splatit nebo částečně splatit. Mimo konec fixace ale banka může účtovat poplatek za předčasné splacení — podmínky se liší, proto je kontrolujeme už při výběru banky.",
  },
];
